import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { CustomerPriceGroupsPage } from "src/components/views/erp/sales/masterData/customerPriceGroups/CustomerPriceGroupsPage.tsx";

export const Route = createFileRoute("/_authenticated/_shell/sales/customerPriceGroups")({
	staticData: { title: i18n.t("customer_price_groups"), legacyViewKey: "customerPriceGroupsPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <CustomerPriceGroupsPage />;
}
